export const getServiceHistoryApiDetails = ({ VIN, state, licensePlate, userVehicleId }) => ({
  method: VIN ? 'findServiceHistoryByVin' : 'findServiceHistoryByLicensePlate',
  payload: VIN ? { userVehicleId, vin: VIN } : { userVehicleId, state, licensePlate }
})
